import { z } from 'zod';
import { timelineDataSchema, timelineItemSchema } from './schema.js';
export const timelineCommandDtoSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('add-section'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        label: z.string().min(1).max(200),
        index: z.number().int().min(0).optional(),
        items: z.array(timelineItemSchema).optional(),
        hidden: z.boolean().optional(),
    }),
    z.object({
        type: z.literal('remove-section'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    }),
    z.object({
        type: z.literal('update-section-label'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        nextLabel: z.string().min(1).max(200),
    }),
    z.object({
        type: z.literal('update-item-title'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        itemId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        nextTitle: z.string().max(200),
    }),
    z.object({
        type: z.literal('create-item'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        item: timelineItemSchema,
        index: z.number().int().min(0).optional(),
    }),
    z.object({
        type: z.literal('change-item-date-range'),
        itemId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        nextRange: z.object({
            sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
            startDate: z.string().datetime({ offset: true }),
            endDate: z.string().datetime({ offset: true }).optional(),
        }),
        targetIndex: z.number().int().min(0).optional(),
    }),
    z.object({
        type: z.literal('delete-item'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/).optional(),
        itemId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    }),
    z.object({
        type: z.literal('move-section'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
        toIndex: z.number().int().min(0),
    }),
    z.object({
        type: z.literal('hide-section'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    }),
    z.object({
        type: z.literal('show-section'),
        sectionId: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    }),
    z.object({
        type: z.literal('replace-snapshot'),
        snapshot: timelineDataSchema,
    }),
]);
